import PropTypes from 'prop-types'
import { isNil } from 'ramda'
import ActiveRecord from 'model/activeRecord'

class DiabetesProgram extends ActiveRecord {
  constructor(init) {
    super(init)
    if (isNil(init)) return undefined
    this._app_downloaded = init.app_downloaded
    this._comorbidities = init.comorbidities
    this._diabetes_type = init.diabetes_type
    this._employee_id = init.employee_id
    this._enrollment_date = init.enrollment_date
    this._id = init.id
    this._medication_names = init.medication_names
  }

  static shape = {
    app_downloaded: PropTypes.bool,
    comorbidities: PropTypes.string,
    diabetes_type: PropTypes.string,
    employee_id: PropTypes.number,
    enrollment_date: PropTypes.string,
    id: PropTypes.number,
    medication_names: PropTypes.string
  }

  get app_downloaded() {
    return this._app_downloaded
  }

  get comorbidities() {
    return this._comorbidities
  }

  get diabetes_type() {
    return this._diabetes_type
  }

  get employee_id() {
    return this._employee_id
  }

  get enrollment_date() {
    return this._enrollment_date
  }

  get id() {
    return this._id
  }

  get medication_names() {
    return this._medication_names
  }
}

export default DiabetesProgram
